// Cross-subdomain consent cookies the app reads (see
// GemeindeWatch_frontend/lib/consent.ts). Keep names, shape and attributes
// (incl. Secure) in sync with that file.

export interface SharedConsent {
  analytics: boolean;
  marketing: boolean;
}

// Registrable domain so the cookie is shared across the landing + app
// subdomains. Host-only on localhost / IPs (browsers reject a domain there).
function getCookieDomainAttribute(): string {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname;
  if (host === "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return "";
  const parts = host.split(".");
  if (parts.length < 2) return "";
  return `; domain=.${parts.slice(-2).join(".")}`;
}

function secureAttribute(): string {
  if (typeof window === "undefined") return "";
  return window.location.protocol === "https:" ? "; Secure" : "";
}

export function writeSharedConsentCookies(preferences: SharedConsent): void {
  if (typeof document === "undefined") return;
  const attrs = `; max-age=31536000; path=/; SameSite=Lax${secureAttribute()}${getCookieDomainAttribute()}`;
  const state = {
    analytics: !!preferences.analytics,
    marketing: !!preferences.marketing,
    timestamp: new Date().toISOString(),
  };
  document.cookie = `ns_consent_given=1${attrs}`;
  document.cookie = `ns_consent=${encodeURIComponent(JSON.stringify(state))}${attrs}`;
}

export function clearSharedConsentCookies(): void {
  if (typeof document === "undefined") return;
  const attrs = `; max-age=0; path=/; SameSite=Lax${secureAttribute()}${getCookieDomainAttribute()}`;
  document.cookie = `ns_consent_given=${attrs}`;
  document.cookie = `ns_consent=${attrs}`;
}
